/* Copyright (c) 2020-present CloudIO Inc */

import { ComponentSample, Item } from 'componentregistry';

const page: {
  root: Item<'Page'>;
  flexPanel: Item<'FlexPanel'>;
  flexItem: Item<'FlexItem'>;
  testAliasLocalDataStore: Item<'LocalDataStore'>;
  testAliasDataStoreReference: Item<'DataStoreReference'>;
  dataGrid: Item<'DataGrid'>;
  idNumberColumn: Item<'NumberColumn'>;
  checkboxColumn: Item<'CheckboxColumn'>;
} = {
  root: {
    children: ['testAliasLocalDataStore', 'flexPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      padding: { all: 0 },
      windowTitle: { type: 'text', value: 'Checkbox Column Example' },
    },
    type: 'Page',
  },
  flexPanel: {
    children: ['flexItem'],
    itemId: 'flexPanel',
    parent: 'root',
    props: {},
    type: 'FlexPanel',
  },
  flexItem: {
    children: ['testAliasDataStoreReference'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  testAliasLocalDataStore: {
    children: [],
    itemId: 'testAliasLocalDataStore',
    parent: 'root',
    props: {
      alias: 'testAlias',
      dataFormat: 'json',
      dataSource: 'test',
      jsonData: `[
  { "id": 1, "active": "Y" },
  { "id": 2, "active": "N" },
  { "id": 3, "active": "Y" },
  { "id": 4, "active": "N" },
  { "id": 5, "active": "Y" }
]`,
    },
    type: 'LocalDataStore',
  },
  testAliasDataStoreReference: {
    children: ['dataGrid'],
    itemId: 'testAliasDataStoreReference',
    parent: 'flexItem',
    props: { alias: 'testAlias' },
    type: 'DataStoreReference',
  },
  dataGrid: {
    children: ['idNumberColumn', 'checkboxColumn'],
    itemId: 'dataGrid',
    parent: 'testAliasDataStoreReference',
    props: {
      expandLastColumn: false,
      showBorder: true,
      updatable: { type: 'boolean', value: true },
      insertable: { type: 'boolean', value: false },
    },
    type: 'DataGrid',
  },

  idNumberColumn: {
    children: [],
    itemId: 'idNumberColumn',
    parent: 'dataGrid',
    props: {
      allowDecimal: false,
      label: { type: 'text', value: 'ID' },
      viewAttribute: 'id',
      width: 60,
    },
    type: 'NumberColumn',
  },
  checkboxColumn: {
    children: [],
    itemId: 'checkboxColumn',
    parent: 'dataGrid',
    props: {
      alignment: 'center',
      label: { type: 'text', value: 'Active' },
      viewAttribute: 'active',
      checkedValue: 'Y',
      unCheckedValue: 'N',
      updatable: { type: 'boolean', value: true },
      displayAsSwitch: false,
      pinLeft: false,
      pinRight: false,
      width: 140,
    },
    type: 'CheckboxColumn',
  },
};

export const helpRenders: ComponentSample<'CheckboxColumn'>[] = [
  {
    title: 'Checkbox Column with Switch Style',
    page,
    exampleId: 'eg-01GK8QWM9KTAE6TN0ME1F8WQCHKSW',
    clearParentChildren: false,
    height: 420,
    visibleProps: [
      'label',
      'alignment',
      'width',
      'viewAttribute',
      'updatable',
      'checkedValue',
      'unCheckedValue',
      'displayAsSwitch',
      'pinLeft',
      'pinRight',
      'sortable',
      'filterable',
      'insertable',
    ],
    item: {
      children: [],
      itemId: 'checkboxColumn',
      parent: 'dataGrid',
      type: 'CheckboxColumn',
      props: {
        alignment: 'center',
        label: { type: 'text', value: 'Active' },
        viewAttribute: 'active',
        checkedValue: 'Y',
        unCheckedValue: 'N',
        updatable: { type: 'boolean', value: true },
        displayAsSwitch: false,
        pinLeft: false,
        pinRight: false,
        width: 140,
      },
    },
  },
];
